"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactShare = require("react-share");

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ShareButton = function ShareButton(_ref) {
  var type = _ref.type,
      pageTitle = _ref.pageTitle,
      url = _ref.url,
      _onClick = _ref.onClick;
  var types = {
    mail: _reactShare.EmailShareButton,
    facebook: _reactShare.FacebookShareButton,
    linkedin: _reactShare.LinkedinShareButton,
    twitter: _reactShare.TwitterShareButton,
    whatsapp: _reactShare.WhatsappShareButton
  };
  var Component = types[type];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Share__item-wrapper",
    onClick: function onClick() {
      return _onClick(type);
    }
  }, /*#__PURE__*/_react.default.createElement(Component, {
    body: pageTitle,
    url: url
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Share__item ".concat(type)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon icon-".concat(type, " icon-variant-3")
  }))));
};

var Share = function Share(_ref2) {
  var title = _ref2.title,
      pageTitle = _ref2.pageTitle,
      url = _ref2.url,
      items = _ref2.items,
      onClick = _ref2.onClick;
  var windowUrl = url || window.location.href;
  var buttons = items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(ShareButton, {
      type: item,
      key: "".concat(item, ":").concat(url),
      pageTitle: pageTitle,
      onClick: onClick,
      url: windowUrl
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Share"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Share__wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Share__title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "Share__buttons"
  }, buttons)));
};

Share.defaultProps = {
  title: 'Share this page:',
  pageTitle: '',
  url: null,
  items: ['mail', 'facebook', 'linkedin', 'twitter', 'whatsapp'],
  onClick: function onClick() {}
};
var _default = Share;
exports.default = _default;